
  import { Options, Vue } from 'vue-class-component';
  import HelloWorld from '../../components/HelloWorld.vue';
  import {DataUtil} from '@/util/DataUtil';
  import {agreementConfig} from '@/config/template';
  import {userAgreementConfig} from "@/config/template_new_user_agreeement";

  @Options({
    components: {
      HelloWorld,
    }
  })
  export default class App extends Vue {
      private temp: string = userAgreementConfig.template_new_protocol_20220427;

    private config: TemplateInterface = {
      // productName: '幸福养猪场',
      // companyFullName: '海南云兆网络技术有限公司',
      // companyShortName: '海南云兆',
      // officialWebsite: 'http://www.hainanyunzhao.com',

        productName: '幸福养猪场',
        companyFullName: '海南云兆网络技术有限公司',
        companyShortName: '海南云兆',
        officialWebsite: 'https://www.hainanyunzhao.com/',
        mail:"2581786904@qq.com",
        cashConfig:`<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
                        <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">游戏中的红包和现金之间的兑换比例是100:1，即100元红包=1元人民币；余额满0.3元（即红包满30元）才能提现；单次提现最高30元；一天最多提现3次；满足上述条件，可全部提现。平台会随机抽取部分幸运用户，提供优惠兑换服务；其中，28级兑换10%，需要用户分别满足，等级达到28级、累计打卡5天、累计拥有过20五行猪；33级兑换20%，需要用户分别满足，等级达到33级、累计打卡10天、累计拥有过25只五行猪；35级兑换30%，需要用户分别满足，等级达到35级、累计打卡15天、累计拥有过30只五行猪；38级兑换50%，需要用户分别满足，等级达到35级、累计打卡20天、累计拥有过35只五行猪；41级兑换100%，需要用户分别满足，等级达到41级、累计打卡25天、累计拥有过40只五行。
元宝提现，50元提现要求元宝账户余额＞＝50元，累计合成3000次，集齐一套五行猪;80元提现要求元宝账户余额＞＝80元，累计合成5000次，集齐一套五行猪；100元提现要求元宝账户余额＞＝100元，累计合成8000次，集齐一套五行猪；200元提现要求元宝账户余额＞＝200元，累计合成10000次，集齐一套五行猪；300元提现要求元宝账户余额＞＝300元，累计合成15000次，集齐一套五行猪；500元提现要求元宝账户余额＞＝500元，累计合成30000次，集齐一套五行猪。</span>
                      </p>`

    };

    mounted(){
      this.temp = DataUtil.replaceConfig(this.temp, this.config);
    }
  }
